"use client";
import React, { useState } from 'react'
import { RxHamburgerMenu, RxQuestionMark } from 'react-icons/rx'
import { SlPower } from 'react-icons/sl'
import '../../header.css'
import Sidebar from '../sidebar/Sidebar'
import LogoutModal from '../logout/LogoutModal';

const Header = () => {
  const[show,setShow] = useState(false)
  const[showLogout,setShowLogout] = useState(false)

  const handleShowLogout = () =>{
    setShowLogout(true)
  }

  const handleCloseLogout = () =>{
    setShowLogout(false)
  }

  return (
    <React.Fragment>
      <div className='app-header'>
        <div className='app-header-content'>
          <div>
            <button className='app-header-menu-btn app-header-btn items-center' onClick={()=>setShow(true)}>
              <RxHamburgerMenu className='icon' />
              <p>Menu</p>
            </button>
          </div>
          <div>
            <span className='app-header-btn'>
              <RxQuestionMark />
            </span>
            <button className='app-header-btn' onClick={handleShowLogout}>
              <SlPower />
            </button>
          </div>
        </div>
      </div>
      <Sidebar show={show} setShow={setShow} /> 
      <LogoutModal show={showLogout} onClose={handleCloseLogout} setShowLogout={setShowLogout} />
    </React.Fragment>
  )
}

export default Header